import { Component, OnInit } from '@angular/core';
import {ParamMap} from '@angular/router';
import {forkJoin, Observable, of} from 'rxjs';
import {mergeMap} from 'rxjs/operators';
import {Pharos_Credentials} from 'src/app/models/RestModels';
import {BaseComponent} from '../base/base.component';

@Component({
	selector: 'app-save-pharos-credentials',
	templateUrl: './save-pharos-credentials.component.html',
	styleUrls: ['./save-pharos-credentials.component.css']
})
export class SavePharosCredentialsComponent extends BaseComponent implements OnInit {
	pharos_credentials:Pharos_Credentials= this.getEmptyPharosCredentials();

	ngOnInit(): void
	{
		this.subs.sink = this.route.paramMap.pipe
		(
			mergeMap((params:ParamMap)=>
			{
				let obs:Observable<Pharos_Credentials> =	params.has('id') ? this.rest.pharos_credentials.get( params.get('id') as string )
					: of( this.getEmptyPharosCredentials() );

				return obs;
			})
		)
		.subscribe((response)=>
		{
			this.pharos_credentials = response;
		})
	}

	getEmptyPharosCredentials():Pharos_Credentials
	{
		return {
			id: 0,
			name: '',
			password: '',
			endpoint: null,
			merchant_code: null,
			terminal_code: '',
			user:'',
			created_by_user_id: null,
			updated_by_user_id: null,
			created: new Date(),
			updated: new Date(),
		} as Pharos_Credentials;
	}

	save()
	{
		this.is_loading = true;

		if( this.pharos_credentials.id )
		{
			this.sink = this.rest.pharos_credentials.update( this.pharos_credentials )
		.subscribe((pharos_credentials)=>{
				this.is_loading = false;
				this.showSuccess('Las credenciales se actualizaron exitosamente');
				this.location.back();
			},(error)=>this.showError(error));
		}
		else
		{
			this.sink = this.rest.pharos_credentials.create( this.pharos_credentials )
			.subscribe((table)=>
			{
				this.is_loading = false;
				this.showSuccess('Las credenciales se guardaron exitosamente');
				this.location.back();
			},(error)=>this.showError(error));
		}
	}

}
